import { getWeekEnd, getWeekStart } from '../utils/dateUtils';

export const formatWeekRangeParts = (date: Date) => {
  const weekStart = getWeekStart(date);
  const weekEnd = getWeekEnd(date);

  const startMonth = weekStart.toLocaleDateString('en-US', { month: 'long' });
  const endMonth = weekEnd.toLocaleDateString('en-US', { month: 'long' });
  const startDay = weekStart.getDate();
  const endDay = weekEnd.getDate();
  const startYear = weekStart.getFullYear();
  const endYear = weekEnd.getFullYear();

  if (startYear === endYear && startMonth === endMonth) {
    return {
      range: `${startMonth} ${startDay}-${endDay}`,
      year: `${startYear}`,
    };
  }

  if (startYear === endYear) {
    return {
      range: `${startMonth} ${startDay} - ${endMonth} ${endDay}`,
      year: `${startYear}`,
    };
  }

  return {
    range: `${startMonth} ${startDay} ${startYear} - ${endMonth} ${endDay}`,
    year: `${endYear}`,
  };
};
